import { t } from "@lingui/macro";
import FitnessAssessment from "@/assets/FitnessAssessment.png";
import useFitnessAssessmentClickHandler from "@/hooks/useFitnessAssessmentClickHandler";
import { AthleteProfileCard } from "@WahooFitness/redesignr";
import { SourcePage } from "@/services/Analytics/EventTypes";

function FitnessAssessmentCard() {
  const { handleFitnessTestClick } = useFitnessAssessmentClickHandler(SourcePage.fitness_profile);
  return (
    <AthleteProfileCard
      imageComponent={
        <img src={FitnessAssessment} alt={`Fitness Assessment`} height="72" width="72" />
      }
      title={t`Fitness Assessment`}
      tag={t`Most accurate`}
      time={t`59 min`}
      actionText={t`View workout`}
      description={t`A workout designed to measure your power in different intensity and time to precisely identify all 4 metrics.`}
      onActionClick={handleFitnessTestClick}
      size="medium"
      variant="elevation"
    />
  );
}

export default FitnessAssessmentCard;
